import {useMutation} from "@tanstack/react-query";
import { resetApi } from "../auth.api";

export const useSendPassword = () => {
  return useMutation(resetApi.resetPassword)
}